import { MenuItems } from '../enums/MenuItems'
import Section from '../components/Section'
import NoRecords from '../components/NoRecords'
import Button from '../components/Button'
import { Pages } from '../Pages'
import LayoutSingleView from '../components/layout/LayoutSingleView'

function NotFound404(): React.JSX.Element {
    return (
        <LayoutSingleView activeMenuItem={MenuItems.Roles}>
            <Section title="">
                <NoRecords caption="Page not found" imgSrc="404.svg">
                    <Button
                        type="link"
                        to={Pages.Roles}
                        style="primary"
                        classes="mt-4"
                    >
                        View Roles
                    </Button>
                </NoRecords>
            </Section>
        </LayoutSingleView>
    )
}

export default NotFound404
